import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { MaterialHint } from 'shared/components';

import theme from './AccountDetailsHint.scss';

const propTypes = {
  children: PropTypes.node.isRequired,
  isTooltipShowed: PropTypes.bool.isRequired,
  userFullName: PropTypes.string.isRequired,
  userEmail: PropTypes.string.isRequired,
};

const AccountDetailsHint = ({
  children,
  isTooltipShowed,
  userFullName,
  userEmail,
}) => (
  isTooltipShowed ? (
    <Fragment>
      { children }
    </Fragment>
    ) : (
      <MaterialHint
        title={
          <Fragment>
            <div>
              <FormattedMessage id="userDetails.view.profileImage.tooltip.patient" defaultMessage="** Account Details" />
            </div>
            <div>{ userFullName }</div>
            <div>{ userEmail }</div>
          </Fragment>
        }
      >
        <div className={ theme.container }>
          { children }
        </div>
      </MaterialHint>
    )
);

AccountDetailsHint.propTypes = propTypes;

export default AccountDetailsHint;
